import { getUser } from '../service/user'

const pattern = /{{([^\s]+)}}/g

const textReplace = content => (_, match) => {
  const replacables = {
    VUE_APP_REPORT_MINIMUM_UNIQUE_USERS: getUser().reportMinimumUsers,
    ...content,
  }

  return match in replacables ? replacables[match] : match
}

export default (text, content) => text.replace(pattern, textReplace(content))
